import type Mithril from 'mithril';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';

import config from '../../common/config';

export interface AnonymousAvatarAttrs extends ComponentAttrs {}

export default class AnonymousAvatar extends Component<AnonymousAvatarAttrs> {
  view(vnode: Mithril.Vnode<AnonymousAvatarAttrs, this>) {
    const { className } = this.attrs;

    return (
      <span className={classList('Avatar', 'Avatar--anonymous', className)}>{app.translator.trans(`${config.module.id}.lib.userMeta.initials`)}</span>
    );
  }
}
